//Animations
VANTA.FOG({
    el: "#hero-warm-shape",
    minHeight: 200.00,
    minWidth: 200.00,
    zoom: 2,
    speed: 3.5,
});
VANTA.FOG({
    el: "#hero-cool-shape",
    minHeight: 200.00,
    minWidth: 200.00,
    zoom: 1.5,
    speed: 1.0,
    highlightColor: "#a6b3fc",
    midtoneColor: "#6c77be",
    lowlightColor: "#2f3769",
    baseColor: "#fcfcfc"
});

function animShow(anim){
    let animEle = document.querySelector(anim);
    animEle.classList.add('loaded');
}
setTimeout(() => {animShow('#hero-warm-shape')}, 500);
setTimeout(() => {animShow('#hero-cool-shape')}, 750);

// Fix for hanging nav colour issue
window.addEventListener('load',function(){
    let scrollDepth = window.pageYOffset;
    let nav = document.querySelector('#header');

    if (scrollDepth > 0){
        nav.classList.add('scroll');
    }
});

var waitForJQueryFooter = setInterval(function () {
    if (typeof $ != 'undefined') {
        // TwentyTwenty before/after plugin
        $.getScript( "//acticoolapparel.com/cdn/shop/t/62/assets/jquery.event.move.js?v=31486725442867323661787263992", function(data, textStatus, jqxhr) {
            if (jqxhr.status == '200'){
                $.getScript( "//acticoolapparel.com/cdn/shop/t/62/assets/jquery.twentytwenty.custom.js?v=60083555684440297541787263992", function(data, textStatus, jqxhr) {
                    //console.log("twentytwenty load was performed.");
                    $("#before_after").twentytwenty();
                });
            }
        });
        clearInterval(waitForJQueryFooter);
    }
}, 10);